import groupBy from 'lodash.groupby';

const getOfficeAuxiliary = (auxiliaryServicesIds, auxiliaries) => {
  const filteredAuxiliary = auxiliaries.filter(
    x => auxiliaryServicesIds.includes(x.id) && x.id !== '7' && x.id !== '9'
  );

  const groupAuxiliary = id => {
    switch (id) {
      case '3':
      case '12':
        return 'camera';
      case '5':
      case '6':
        return 'wifi';
      case '8':
        return 'wheelchair';
      default:
        return 'additional';
    }
  };

  return groupBy(filteredAuxiliary, item => groupAuxiliary(item.id));
};

export default getOfficeAuxiliary;
